import { FixedOptionMultiSelectInput, type FixedOptionMultiSelectInputProps } from '../fixed-option-select-input/fixed-option-multi-select-input';
import { type BaseEnumOptionInputProps, useEnumFixedOptionInputProps } from './shared';

export type EnumMultiSelectInputProps<TEnum extends Record<string, TValue>, TValue extends string = string> = Omit<
  FixedOptionMultiSelectInputProps<TValue>,
  'i18nPrefix' | 'i18nValueName' | 'optionValues'
> &
  BaseEnumOptionInputProps<TEnum, TValue>;

export function EnumMultiSelectInput<TEnum extends Record<string, TValue>, TValue extends string = string>({
  enumValue,
  enumName,
  ...rest
}: EnumMultiSelectInputProps<TEnum, TValue>) {
  const enumValues = useEnumFixedOptionInputProps<TEnum, TValue>({ enumName, enumValue });

  return <FixedOptionMultiSelectInput<TValue> {...enumValues} {...rest} />;
}
